module.exports = __webpack_public_path__ + "static/media/wetterau.a15b9a02.png";